import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { setFindAllSelectRowCol} from '../../../actions/transOperation_find_Actions';

class FindAllView_list extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    async componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
        }
    }

    render() {

        const {FindAllList} = this.props;

        const {findAllTargetData,tableColNameMapping,tableColMapping} = this.props.transOperation;
        let mainContent;


        let listView;
        let findAllTargetDataCount = 0;
        if(FindAllList !== null){

            listView = FindAllList.map((obj,index)=>{
                const {targetTitle,type,rowIndex} = obj;

                return <li className='findAllObj'>
                    <a
                        onClick={() => {
                            // alert(rowIndex);
                            // this.props.setFindAllSelectRowCol([rowIndex,tableColMapping[`${type}`]]);

                            this.props.setDoubleClick(rowIndex);
                    }} >Line {rowIndex+1} [{tableColNameMapping[`${type}`]}] {targetTitle}</a>
                </li>;

            })

            findAllTargetDataCount = findAllTargetData.length;
        }


        mainContent = <div className='small' style={{height:`${window.innerHeight-680}px`,overflowY:"scroll"}}>
            <b>
                Find Results ({FindAllList.length} rows)
            </b>
            <ul>
                {listView}
            </ul>
        </div>;

        return (mainContent);
    }
}


FindAllView_list.propTypes = {
    errors: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    project: state.project,
    errors: state.errors,
    transOperation: state.transOperation
});

export default connect(mapStateToProps, { setFindAllSelectRowCol })(
    withRouter(FindAllView_list)
);



// WEBPACK FOOTER //
// ./src/components/translations/objects/FindAllView_list.js